import axiosInstance from "../../Utils/axiosInstance";

export type PnlRow = {
  book: string;
  strategy: string;
  daily_change: number;
  cost: number;
  optimisation_margin: number;
  pnl: number;
  markup_pnl: number;
  commercial_pnl: number;
  jv_total_pnl: number;
  jv_partner_pnl: number;
  cgm_pnl: number;
  net_pnl: number;
};

const SNAPSHOT_NUMERIC_KEYS = [
  "daily_change",
  "cost",
  "optimisation_margin",
  "pnl",
  "markup_pnl",
  "commercial_pnl",
  "jv_total_pnl",
  "jv_partner_pnl",
  "cgm_pnl",
  "net_pnl",
] as const;

export type PnlSnapshotPayload = {
  date: string;
  data: PnlRow[];
};

export type PnlSnapshotRow = PnlRow & {
  id: string;
  date: string;
};

export type PnlSnapshotType = "all" | "daily_pnl_change" | "monthly_change" | "all_month_end";

export const fetchPnlSummaryView3 = async (): Promise<PnlRow[]> => {
  const res = await axiosInstance.get<PnlRow[]>("/paper-app/pnl-summary-view3/");
  return res.data ?? [];
};


export const updateDailyChangeCloud2 = async (): Promise<void> => {
  await axiosInstance.get("/paper-app/update-dailychange-cloud2/");
};

export const takeDailyPnlSnapshot = async (payload: PnlSnapshotPayload): Promise<void> => {
  await axiosInstance.post("/paper-app/daily-pnl-snapshot/", payload);
};

const mapSnapshotRows = (raw: any): PnlSnapshotRow[] => {
  const results = raw?.results ?? raw ?? [];
  return (results as any[]).map(r => {
    const row: any = { id: r.id, date: r.date, book: r.book, strategy: r.strategy };
    SNAPSHOT_NUMERIC_KEYS.forEach(key => {
      row[key] = Number(r[key]) || 0;
    });
    return row as PnlSnapshotRow;
  });
};

const SNAPSHOT_BASE_URL: Record<PnlSnapshotType, string> = {
  all: "/paper-app/daily-pnl-snapshot-list/",
  daily_pnl_change: "/paper-app/daily-pnl-snapshot-list/",
  monthly_change: "/paper-app/daily-pnl-snapshot-list/",
  all_month_end: "/paper-app/daily-pnl-snapshot-list/",
};


export const fetchPnlSnapshotByType = async (
  type: PnlSnapshotType,
  period?: string
): Promise<PnlSnapshotRow[]> => {
  const res = await axiosInstance.get(SNAPSHOT_BASE_URL[type], {
    params: period ? { type, date: period } : { type },
  });
  return mapSnapshotRows(res.data);
};
 